import { useState, useEffect } from "react";

export function useWindowSize() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 600);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Ensure it runs on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isDesktop };
}